<script setup>
defineProps({
  formClass: {
    type: [Array, Object, String]
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <li role="presentation">
    <div
      v-bind="$attrs"
      :class="[formClass, { disabled }]"
      :tabindex="disabled ? null : '-1'"
    >
      <slot></slot>
    </div>
  </li>
</template>

<style scoped lang="scss"></style>
